module.exports = __webpack_public_path__ + "img/Sims4.305a2bde.jpg";